import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID,
      signUpVerificationMethod: "code",
    },
  },

  Storage: {
    S3: {
      bucket: import.meta.env.VITE_BUCKET,
      region: import.meta.env.VITE_AWS_REGION,
    },
  },
});
